import getSuggestions from '../actions/getSuggestions';
import onPillSuggestionSelected from '../actions/onPillSuggestionSelected';
import onRemoveSuggestionPill from '../actions/onRemoveSuggestionPill';
import onRemoveSuggestionPillInternal from '../actions/onRemoveSuggestionPillInternal';
import onSearchTextChanged from '../actions/onSearchTextChanged';
import startSearch from '../actions/startSearch';
import isSearchBoxEmpty from '../selectors/isSearchBoxEmpty';
import getScenarioStore from '../store/getScenarioStore';
import { orchestrator } from 'satcheljs';

orchestrator(onPillSuggestionSelected, actionMessage => {
    const { suggestionSelected, scenarioId } = actionMessage;

    // Clear search text (since suggestion pill was picked based on search text).
    if (suggestionSelected) {
        onSearchTextChanged('', scenarioId, false /* showSuggestionsUi */);
    }
});

orchestrator(onRemoveSuggestionPill, actionMessage => {
    const { scenarioId, suggestionPillId } = actionMessage;

    const store = getScenarioStore(scenarioId);
    const suggestionPillIndex = store.suggestionPillIds.indexOf(suggestionPillId);

    // Throw if suggestion to remove isn't found in the store.
    if (suggestionPillIndex === -1) {
        throw new Error(
            'onRemoveSuggestionPill action should not be dispatched when the suggestion is not present in the store.'
        );
    }

    /**
     * Dispatch action to remove suggestion pill from the store. This is done
     * within this orchestrator insteading having an explicit mutator because
     * order matters and it must happen before checking if the search box is
     * empty.
     */
    onRemoveSuggestionPillInternal(suggestionPillId, suggestionPillIndex, scenarioId);

    /**
     * After suggestion pill is removed, check if search box is empty. If search
     * box is not empty, dispatch a startSearch action to initiate search.
     *
     * If search box is empty, dispatch getSuggestions since search box content
     * has changed.
     */
    if (!isSearchBoxEmpty(scenarioId)) {
        startSearch('NonUserAction', scenarioId);
    } else {
        getSuggestions(scenarioId);
    }
});
